// Reported browser information, not a fingerprint or an inferred physical location.
export const signupContext = (): Record<string, string> => {
  let timeZone = '';
  try { timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch { /* optional */ }
  return { userAgent: navigator.userAgent.slice(0, 500), timeZone, language: navigator.language || '' };
};
